import { Session } from '@ais-ui/auth';

export type BackendReplayRange = {
  endDay: number;
  endHour: number;
  endMin: number;
  endMonth: number;
  endSec: number;
  endTime: number;
  endTimeStr: string;
  endYear: number;
  startDay: number;
  startHour: number;
  startMin: number;
  startMonth: number;
  startSec: number;
  startTime: number;
  startTimeStr: string;
  startYear: number;
};

export const getReplayRange = async (
  session: Session
): Promise<BackendReplayRange> => {
  const response = await session.request('getReplayRange', {
    serverUid: 'd4bd4710-1765-4476-8969-09ab9d0b676f',
  });

  return response;
};
